module.exports = __webpack_public_path__ + "img/设计打样.4039c50d.png";